<template>
<!-- <v-app style="background-color:transparent;"> -->
  <!-- <div class="md-layout">
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <i class="fab fa-twitter"></i>
          </div>
          <p class="category">Folowers</p>
          <h3 class="title">
            +245
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Just Updated
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="rose">
        <template slot="header">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <p class="category">Website Visits</p>
          <h3 class="title">
            75.521
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>local_offer</md-icon>
            Tracked from Google Analytics
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>store</md-icon>
          </div>
          <p class="category">Revenue</p>
          <h3 class="title">
            $ 34.245
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>date_range</md-icon>
            Last 24 Hours
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="warning">
        <template slot="header">
          <div class="card-icon">
            <md-icon>weekend</md-icon>
          </div>
          <p class="category">Bookings</p>
          <h3 class="title">
            184
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon class="text-danger">warning</md-icon>
            <a href="#pablo">Get More Space...</a>
          </div>
        </template>
      </stats-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        :chart-data="fakturMonthlyChart.data"
        :chart-options="fakturMonthlyChart.options"
        :chart-responsive-options="fakturMonthlyChart.responsiveOptions"
        chart-type="Bar"
        chart-inside-header
        background-color="rose"
      >
        <md-icon slot="fixed-button">build</md-icon>
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button class="md-simple md-just-icon" slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Website Views</h4>
          <p class="category">
            Last Campaign Performance
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            updated 10 days ago
          </div>
        </template>
      </chart-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        :chart-data="dailySalesChart.data"
        :chart-options="dailySalesChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="green"
      >
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button class="md-simple md-just-icon" slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Daily Sales</h4>
          <p class="category">
            <span class="text-success"
              ><i class="fas fa-long-arrow-alt-up"></i>
              55%
            </span>
            increase in today sales.
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            updated 4 minutes ago
          </div>
        </template>
      </chart-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        :chart-data="dataCompletedTasksChart.data"
        :chart-options="dataCompletedTasksChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="blue"
      >
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button class="md-simple md-just-icon" slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Completed Tasks</h4>
          <p class="category">
            Last Campaign Performance
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            campaign sent 26 minutes ago
          </div>
        </template>
      </chart-card>
    </div>

    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-warning">
          <div class="card-text">
            <h4 class="title">Employees Stats</h4>
            <p class="category">
              New employees on 15th September, 2016
            </p>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table v-model="users" table-header-color="orange">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Id">{{ item.id }}</md-table-cell>
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Salary">{{ item.salary }}</md-table-cell>
              <md-table-cell md-label="Country">{{ item.country }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <nav-tabs-card>
        <template slot="content">
          <span class="md-nav-tabs-title">Tasks</span>
          <md-tabs md-sync-route class="md-rose" md-alignment="left">
            <md-tab id="tab-home" md-label="Bugs" md-icon="bug_report">
              <md-table v-model="firstTabs" @md-selected="onSelect">
                <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    md-selectable="multiple"
                    md-auto-select
                >
                  <md-table-cell>{{ item.tab }}</md-table-cell>
                  <md-table-cell>
                    <md-button class="md-just-icon md-simple md-primary">
                      <md-icon>edit</md-icon>
                      <md-tooltip md-direction="top">Edit</md-tooltip>
                    </md-button>
                    <md-button class="md-just-icon md-simple md-danger">
                      <md-icon>close</md-icon>
                      <md-tooltip md-direction="top">Close</md-tooltip>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>

            <md-tab id="tab-pages" md-label="Website" md-icon="code">
              <md-table v-model="secondTabs" @md-selected="onSelect">
                <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    md-selectable="multiple"
                    md-auto-select
                >
                  <md-table-cell>{{ item.tab }}</md-table-cell>
                  <md-table-cell>
                    <md-button class="md-just-icon md-simple md-primary">
                      <md-icon>edit</md-icon>
                      <md-tooltip md-direction="top">Edit</md-tooltip>
                    </md-button>
                    <md-button class="md-just-icon md-simple md-danger">
                      <md-icon>close</md-icon>
                      <md-tooltip md-direction="top">Close</md-tooltip>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>

            <md-tab id="tab-posts" md-label="Server" md-icon="cloud">
              <md-table v-model="thirdTabs" @md-selected="onSelect">
                <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    md-selectable="multiple"
                    md-auto-select
                >
                  <md-table-cell>{{ item.tab }}</md-table-cell>
                  <md-table-cell>
                    <md-button class="md-just-icon md-simple md-primary">
                      <md-icon>edit</md-icon>
                      <md-tooltip md-direction="top">Edit</md-tooltip>
                    </md-button>
                    <md-button class="md-just-icon md-simple md-danger">
                      <md-icon>close</md-icon>
                      <md-tooltip md-direction="top">Close</md-tooltip>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>

          </md-tabs>
        </template>
      </nav-tabs-card>
    </div>

  </div> -->
  <div v-if="me" class="md-layout">
    
    <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100" style="text-align:left; background-color:white; ">
    <!-- <md-card style="background-color:#a9afff;"> -->
      <md-card-content>
        
          <h4 style="font-weight:bold; margin-left:20px;">Selamat datang, {{ me.name }} !</h4>
          <h6 style="margin-left:20px;">Sekarang, {{ today }}</h6>
        
      </md-card-content>
    <!-- </md-card> -->
    </div>

    <div class="md-layout-item md-medium-size-100 md-size-70 md-small-size-100" style="background-color:white; ">
    <!-- <md-card style="background-color:#a9afff; "> -->
      <div class="md-layout-item md-small-size-100 md-size-100" style="margin-top:20px; margin-bottom:40px; ">
        
        <img style="width:250px; height:400px; float:right; margin-right:50px; margin-top:30px;" class="md-small-hide md-medium-hide" src="@/assets/images/Imagecewek.png" />
        <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-50" style="margin-left:20px;">
          <!-- <h4 style="font-weight:bold; text-align:left;">Apa yang bisa aku bantu ?</h4> -->
          <v-expansion-panels style="margin-top:20px; " v-model="panel"  multiple>
           
           
        <!-- <v-expansion-panel style="background-color:#687dff;"
        >
          <v-expansion-panel-header>
            Item
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel> -->
          </v-expansion-panels>
          
        </div>
          </div>
    <!-- </md-card> -->
    </div>


    <div id="app" class="md-layout-item md-size-30 md-small-size-100 md-small-hide md-medium-hide">
      <v-carousel hide-delimiters :show-arrows="false" cycle>
        <v-carousel-item
          v-for="(item,i) in itemsCro"
          :key="i"
          :src="item.src"
        ></v-carousel-item>
      </v-carousel>
    </div>
    

  </div>

  
  <!-- </v-app> -->
</template>

<script>
// import Pagination from "@/components/Pagination";
// import { Modal } from "@/components";
import vuetify from '@/plugins/vuetify';
import {
  StatsCard,
  // ChartCard,
  NavTabsCard
} from "@/components";

const toLower = text => {
  var rt = ""
    if(text){
       rt = text.toString().toLowerCase()
    }
    return rt
  }
export default {
  vuetify,
  // props: {
  //   user: Object,
  // },
  components: {
    //  pagination: Pagination,
    // StatsCard,
    // ChartCard,
    // NavTabsCard
    // Modal,
    
  },

  data() {
    return {
      itemsCro: [
          // {
          //   src: require('@/assets/images/foto1.jpg')
          // },
          // {
          //   src: require('@/assets/images/foto2.png')
          // },
          // {
          //   src: require('@/assets/images/foto3.jpg')
          // },
          
        ],
      images: [
        {
      src:"@/assets/images/Imagecewek.png"
    },
        ],
      timer: null,
      currentIndex: 0,
      me:null,
      panel: [0],
      active: 'first',
      first:false,
      today:null,
      procure: [],
      tableProcurementOrder: [],
      tablePartThresholder: [],
      tableRepairStatus: [],
    
      tablePagefilterPartThresholder: [],
      tablePagePartThresholder: [],
      footerTablePartThresholder: [],
      searchPartThresholder: null,

      tablePagefilterProcurementOrder: [],
      tablePageProcurementOrder: [],
      footerTableProcurementOrder: [],
      searchProcurementOrder: null,

      tablePagefilterRepairStatus: [],
      tablePageRepairStatus: [],
      footerTableRepairStatus: [],
      searchRepairStatus: null,
    
      queryProcurementOrder: null,
      queryPartThresholder: null,
      queryRepairStatus: null,

      sortationPartThresholder: {
        field: "spare_part_master_name",
        order: "desc",
      },
      sortationProcurementOrder: {
        field: "procurement_order_no",
        order: "desc",
      },
      sortationRepairStatus: {
        field: "pkb_no",
        order: "desc",
      },

      paginationPartThresholder: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [1,3, 5, 10, 25, 50],
      },
      paginationProcurementOrder: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [1,3, 5, 10, 25, 50],
      },
      paginationRepairStatus: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [1,3, 5, 10, 25, 50],
      },


      totalProcurementOrder: 0,
      totalPartThresholder: 0,
      totalRepairStatus: 0,

      // product1: process.env.VUE_APP_BASE_URL + "/img/card-2.jpg",
      // product2: process.env.VUE_APP_BASE_URL + "/img/card-3.jpg",
      // product3: process.env.VUE_APP_BASE_URL + "/img/card-1.jpg",
      // seq2: 0,

      // selected: [],
      // firstTabs: [
      //   { tab: "Sign contract for \"What are conference organizers afraid of?\""},
      //   { tab: "Lines From Great Russian Literature? Or E-mails From My Boss?" },
      //   { tab: "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit" },
      //   { tab: "Create 4 Invisible User Experiences you Never Knew About" }
      // ],
      // secondTabs: [
      //   {
      //     tab:
      //       "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit"
      //   },
      //   {
      //     tab:
      //       "Sign contract for \"What are conference organizers afraid of?\""
      //   }
      // ],
      // thirdTabs: [
      //   {
      //     tab:
      //       "Lines From Great Russian Literature? Or E-mails From My Boss?"
      //   },
      //   {
      //     tab:
      //       "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit"
      //   },
      //   {
      //     tab:
      //       "Sign contract for \"What are conference organizers afraid of?\""
      //   }
      // ],

      // users: [
      //   {
      //     id: 1,
      //     name: "Noelia O'Kon",
      //     salary: "13098.00",
      //     country: "Niger"
      //   },
      //   {
      //     id: 2,
      //     name: "Mr. Enid Von PhD",
      //     salary: "35978.00",
      //     country: "Curaçao"
      //   },
      //   {
      //     id: 3,
      //     name: "Colton Koch",
      //     salary: "26278.00",
      //     country: "Netherlands"
      //   },
      //   {
      //     id: 4,
      //     name: "Gregory Vandervort",
      //     salary: "25537.00",
      //     country: "South Korea"
      //   },
      // ],
      // dailySalesChart: {
      //   data: {
      //     labels: ["M", "T", "W", "T", "F", "S", "S"],
      //     series: [[12, 17, 7, 17, 23, 18, 38]]
      //   },
      //   options: {
      //     lineSmooth: this.$Chartist.Interpolation.cardinal({
      //       tension: 0
      //     }),
      //     low: 0,
      //     high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      //     chartPadding: {
      //       top: 0,
      //       right: 0,
      //       bottom: 0,
      //       left: 0
      //     }
      //   }
      // },
      // dataCompletedTasksChart: {
      //   data: {
      //     labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
      //     series: [[230, 750, 450, 300, 280, 240, 200, 190]]
      //   },

      //   options: {
      //     lineSmooth: this.$Chartist.Interpolation.cardinal({
      //       tension: 0
      //     }),
      //     low: 0,
      //     high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      //     chartPadding: {
      //       top: 0,
      //       right: 0,
      //       bottom: 0,
      //       left: 0
      //     }
      //   }
      // },
      // emailsSubscriptionChart: {
      //   data: {
      //     labels: [
      //       "Ja",
      //       "Fe",
      //       "Ma",
      //       "Ap",
      //       "Mai",
      //       "Ju",
      //       "Jul",
      //       "Au",
      //       "Se",
      //       "Oc",
      //       "No",
      //       "De"
      //     ],
      //     series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
      //   },
      //   options: {
      //     axisX: {
      //       showGrid: false
      //     },
      //     low: 0,
      //     high: 1000,
      //     chartPadding: {
      //       top: 0,
      //       right: 5,
      //       bottom: 0,
      //       left: 0
      //     }
      //   },
      //   responsiveOptions: [
      //     [
      //       "screen and (max-width: 640px)",
      //       {
      //         seriesBarDistance: 5,
      //         axisX: {
      //           labelInterpolationFnc: function(value) {
      //             return value[0];
      //           }
      //         }
      //       }
      //     ]
      //   ]
      // }

      fakturNotaJasaChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          chartPadding: {
            top: 40,
            right: 5,
            bottom: 0,
            left: 30
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },

      fakturNotaPartChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          chartPadding: {
            top: 40,
            right: 5,
            bottom: 0,
            left: 30
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      }


    };
  },
  

  computed:{
    currentImg: function() {
        return this.images[Math.abs(this.currentIndex) % this.images.length];
      },

    fromPartThresholder() {
      
      return this.paginationPartThresholder.perPage * (this.paginationPartThresholder.currentPage - 1);
    },

    toPartThresholder() {
      
      let highBound = this.fromPartThresholder + this.paginationPartThresholder.perPage;
      if (this.totalPartThresholder < highBound) {
        highBound = this.totalPartThresholder;
      }
      return highBound;
    },

    fromProcurementOrder() {
      
      return this.paginationProcurementOrder.perPage * (this.paginationProcurementOrder.currentPage - 1);
    },

    toProcurementOrder() {
      
      let highBound = this.fromProcurementOrder + this.paginationProcurementOrder.perPage;
      if (this.totalProcurementOrder < highBound) {
        highBound = this.totalProcurementOrder;
      }
      return highBound;
    },

    fromRepairStatus() {
      
      return this.paginationRepairStatus.perPage * (this.paginationRepairStatus.currentPage - 1);
    },

    toRepairStatus() {
      
      let highBound = this.fromRepairStatus + this.paginationRepairStatus.perPage;
      if (this.totalRepairStatus < highBound) {
        highBound = this.totalRepairStatus;
      }
      return highBound;
    },

  },

  mounted: function() {
      this.startSlide();
    },

  created() {
      this.getData();

    },
  methods: {
startSlide: function() {
        this.timer = setInterval(this.next, 4000);
      },
  
  
      next: function() {
        this.currentIndex += 1
      },
      prev: function() {
        this.currentIndex -= 1
      },
    
    // ambil data yang dibutuhkan
    async getData(){
      

      this.me = await this.$store.getters["profile/me"]
      await this.$store.dispatch("workshop_dashboard/fakturNotaJasa")
      //this.nota_part = await this.$store.getters["workshop_nota_part/nota_part"]
      let labelsNotaJasa=[]
      let nilaiNotaJasa=[]

      var objToday = new Date(),
        weekday = new Array('Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'),
        dayOfWeek = weekday[objToday.getDay()],
        domEnder = function() { var a = objToday; if (/1/.test(parseInt((a + "").charAt(0)))) return "th"; a = parseInt((a + "").charAt(1)); return 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th" }(),
        dayOfMonth = today + ( objToday.getDate() < 10) ? '0' + objToday.getDate() + domEnder : objToday.getDate() + domEnder,
        months = new Array('Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'Desember'),
        curMonth = months[objToday.getMonth()],
        curYear = objToday.getFullYear(),
        curHour = objToday.getHours() > 12 ? objToday.getHours() - 12 : (objToday.getHours() < 10 ? "0" + objToday.getHours() : objToday.getHours()),
        curMinute = objToday.getMinutes() < 10 ? "0" + objToday.getMinutes() : objToday.getMinutes(),
        curSeconds = objToday.getSeconds() < 10 ? "0" + objToday.getSeconds() : objToday.getSeconds(),
        curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";
      var today = dayOfWeek + " " + dayOfMonth + "  " + curMonth + ", " + curYear;

      this.today = today;

      // check data dashboard null atau tidak
      if(await this.$store.getters["workshop_dashboard/dashboard"] && await this.$store.getters["workshop_dashboard/dashboard"].length!=0){
        await this.$store.getters["workshop_dashboard/dashboard"].map(function(value, key) {
        labelsNotaJasa.push(value.monthNotaJasa);
        nilaiNotaJasa.push(value.totalNotaJasa);
        });
        this.fakturNotaJasaChart.data.labels = labelsNotaJasa
        this.fakturNotaJasaChart.data.series = [nilaiNotaJasa]

        console.log(this.fakturNotaJasaChart.data.labels)
      }
      

      await this.$store.dispatch("workshop_dashboard/fakturNotaPart")
      //this.nota_part = await this.$store.getters["workshop_nota_part/nota_part"]
      let labelsNotaPart=[]
      let nilaiNotaPart=[] 

     if(await this.$store.getters["workshop_dashboard/dashboard"] && await this.$store.getters["workshop_dashboard/dashboard"].length!=0){
          await this.$store.getters["workshop_dashboard/dashboard"].map(function(value, key) {
            labelsNotaPart.push(value.monthNotaPart);
            nilaiNotaPart.push(value.totalNotaPart);
          });
          this.fakturNotaPartChart.data.labels = labelsNotaPart
          this.fakturNotaPartChart.data.series = [nilaiNotaPart]
      }

      

      // await this.$store.dispatch("procurementOrder/dashboard")
      // await this.$store.getters["workshop_dashboard/dashboard"]

      await this.$store.dispatch("workshop_dashboard/procurementOrder")

      if(await this.$store.getters["workshop_dashboard/dashboard"] && await Object.keys(this.$store.getters["workshop_dashboard/dashboard"]).length!=0){
          this.tableProcurementOrder = await this.$store.getters["workshop_dashboard/dashboard"]
          this.tablePagefilterProcurementOrder = this.paginate(this.tableProcurementOrder, this.paginationProcurementOrder.perPage)
          this.tablePageProcurementOrder = this.tablePagefilterProcurementOrder[this.paginationProcurementOrder.currentPage-1]
          this.totalProcurementOrder =  this.tableProcurementOrder.length
      
      }
      
      await this.$store.dispatch("workshop_dashboard/repairStatus")
       if(await this.$store.getters["workshop_dashboard/dashboard"] && await Object.keys(this.$store.getters["workshop_dashboard/dashboard"]).length!=0){
          this.tableRepairStatus = await this.$store.getters["workshop_dashboard/dashboard"]
          this.tablePagefilterRepairStatus = this.paginate(this.tableRepairStatus, this.paginationRepairStatus.perPage)
          this.tablePageRepairStatus = this.tablePagefilterRepairStatus[this.paginationRepairStatus.currentPage-1]
          this.totalRepairStatus =  this.tableRepairStatus.length
      
      }
      
        
      await this.$store.dispatch("workshop_dashboard/traceHold")
      console.log('weweew')
       if(await this.$store.getters["workshop_dashboard/dashboard"] && await Object.keys(this.$store.getters["workshop_dashboard/dashboard"]).length!=0){
         
         this.tablePartThresholder = await this.$store.getters["workshop_dashboard/dashboard"]
          this.tablePagefilterPartThresholder = this.paginate(this.tablePartThresholder, this.paginationPartThresholder.perPage)
          this.tablePagePartThresholder = this.tablePagefilterPartThresholder[this.paginationPartThresholder.currentPage-1]
          this.totalPartThresholder =  this.tablePartThresholder.length
          
          console.log(await this.$store.getters["workshop_dashboard/dashboard"])  
      }
      
    },
    onSelect: function(items) {
      this.selected = items;
    },

    onPagination (jenis) {
       //console.log(this.pagination.currentPage)
       if(jenis == "PartThresholder"){
         this.tablePagePartThresholder = this.tablePagefilterPartThresholder[this.paginationPartThresholder.currentPage-1]
       }

       if(jenis == "ProcurementOrder"){
         this.tablePageProcurementOrder = this.tablePagefilterProcurementOrder[this.paginationProcurementOrder.currentPage-1]
       }

       if(jenis == "RepairStatus"){
         this.tablePageRepairStatus = this.tablePagefilterRepairStatus[this.paginationRepairStatus.currentPage-1]
       }
    },

    onPerPage(jenis){
      if(jenis == "PartThresholder"){
        this.tablePagefilterPartThresholder = this.paginate(this.tablePartThresholder, this.paginationPartThresholder.perPage)
        this.tablePagePartThresholder = this.tablePagefilterPartThresholder[this.paginationPartThresholder.currentPage-1]
      }

      if(jenis == "ProcurementOrder"){
        this.tablePagefilterProcurementOrder = this.paginate(this.tableProcurementOrder, this.paginationProcurementOrder.perPage)
        this.tablePageProcurementOrder = this.tablePagefilterProcurementOrder[this.paginationProcurementOrder.currentPage-1]
      }

      if(jenis == "RepairStatus"){
        this.tablePagefilterRepairStatus = this.paginate(this.tableRepairStatus, this.paginationRepairStatus.perPage)
        this.tablePageRepairStatus = this.tablePagefilterRepairStatus[this.paginationRepairStatus.currentPage-1]
      }
    },
    paginate (arr, size) {
      return arr.reduce((acc, val, i) => {
        let idx = Math.floor(i / size)
        let page = acc[idx] || (acc[idx] = [])
        page.push(val)

        return acc
      }, [])
    },
    searchOnTable (jenis) {
      if(jenis == "PartThresholder"){
          var resultFilter = []
          resultFilter = this.tablePartThresholder.filter(item => toLower(item.spare_part_master_code).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_name).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_unit).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_unit_price).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_type).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_category).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_alert_price).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.created_at).includes(toLower(this.searchPartThresholder))
                                          )
                                
          if(resultFilter.length != 0){
            this.totalPartThresholder = resultFilter.length
            this.tablePagefilterPartThresholder = this.paginate(resultFilter, this.paginationPartThresholder.perPage)
            this.tablePagePartThresholder = this.tablePagefilterPartThresholder[this.paginationPartThresholder.currentPage-1]
            
          }
          else{
            this.tablePagePartThresholder = [] 
          }
      }


      if(jenis == "ProcurementOrder"){
          var resultFilter = []
          resultFilter = this.tableProcurementOrder.filter(item => toLower(item.procurement_order_no).includes(toLower(this.searchProcurementOrder)) ||
                                                  toLower(item.procurement_order_status).includes(toLower(this.searchProcurementOrder)) ||
                                                  toLower(item.created_at).includes(toLower(this.searchProcurementOrder))
                                          )
                                
          if(resultFilter.length != 0){
            this.totalProcurementOrder = resultFilter.length
            this.tablePagefilterProcurementOrder = this.paginate(resultFilter, this.paginationProcurementOrder.perPage)
            this.tablePageProcurementOrder = this.tablePagefilterProcurementOrder[this.paginationProcurementOrder.currentPage-1]
            
          }
          else{
            this.tablePageProcurementOrder = [] 
          }
      }

      if(jenis == "RepairStatus"){
          var resultFilter = []
          resultFilter = this.tableRepairStatus.filter(item => toLower(item.pkb_no).includes(toLower(this.searchRepairStatus)) ||
                                                  toLower(item.procurement_order_status).includes(toLower(this.searchRepairStatus)) ||
                                                  toLower(item.created_at).includes(toLower(this.searchRepairStatus))
                                          )
                                
          if(resultFilter.length != 0){
            this.totalRepairStatus = resultFilter.length
            this.tablePagefilterRepairStatus = this.paginate(resultFilter, this.paginationRepairStatus.perPage)
            this.tablePageRepairStatus = this.tablePagefilterRepairStatus[this.paginationRepairStatus.currentPage-1]
            
          }
          else{
            this.tablePageRepairStatus = [] 
          }
      }
      
      
       
      },

      addDaily() {
      this.$refs.modalAddDailyReportPage.openModal({mode: "dashboard"});
      },
      modalCloseAddDailyReport() {
        this.$refs.modalAddDailyReportPage.closeModal();
        // this.getList();
      },

      addRental() {
      this.$refs.modalAddRentalPage.openModal({mode: "dashboard"});
      },
      modalCloseAddRental() {
        this.$refs.modalAddRentalPage.closeModal();
        // this.getList();
      },

      addIt() {
      this.$refs.modalAddItPage.openModal({mode: "dashboard"});
      },
      modalCloseAddIt() {
        this.$refs.modalAddItPage.closeModal();
        // this.getList();
      },

    //   addDaily() {
    //   // panggil add page
    //  this.$router.push({ name: "Add Daily Report" });
    // },

    // addRental() {
    //   // panggil add page
    //  this.$router.push({ name: "Add Rental Vehicle Employee" });
    // },

    // addIt() {
    //   // panggil add page
    //  this.$router.push({ name: "Add IT Request" });
    // },
      
  }
};
</script>
<style scoped>
.v-expansion-panel-content{
  font-size:15px !important;
  text-align:left !important;
}
/* .v-expansion-panel-header{
  font-weight:bold;
} */

/* .v-carousel{
  height:300px;
} */

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
